import React from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Form, FormField } from '@/components/ui/form';
import InlineInput from '@/components/InlineInput';
import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';

import { documentCategorySchema, IDocumentCategory } from './schema';
export * from './schema';

interface IProps {
  defaultValues?: DefaultValues<IDocumentCategory>;
  onSubmit: SubmitHandler<IDocumentCategory>;
}

const DocumentCategoryForm: React.FC<IProps> = ({
  defaultValues,
  onSubmit,
}) => {
  const form = useForm<IDocumentCategory>({
    defaultValues: {
      description: '',
      color: '#FFFFFF',
      ...defaultValues,
    },
    resolver: zodResolver(documentCategorySchema),
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid gap-4 py-4">
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <InlineInput
                title="Descrição"
                placeholder="Nome da categoria"
                disabled={form.formState.isSubmitting}
                {...field}
              />
            )}
          />
          <FormField
            control={form.control}
            name="color"
            render={({ field }) => (
              <InlineInput
                title="Cor"
                type="color"
                disabled={form.formState.isSubmitting}
                {...field}
              />
            )}
          />
        </div>
        <DialogFooter>
          <Button type="submit" disabled={form.formState.isSubmitting}>
            {form.formState.isSubmitting && (
              <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
            )}
            Salvar
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};

export default DocumentCategoryForm;
